var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFront = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 22.5686H8.25233V8.22275H22.712V1H1V22.5686Z",
    fill: "#A857F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4576 23C20.0709 23 23 20.0708 23 16.4575C23 12.8442 20.0709 9.91508 16.4576 9.91508C12.8444 9.91508 9.91528 12.8442 9.91528 16.4575C9.91528 20.0708 12.8444 23 16.4576 23Z",
    fill: "#A857F1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFront);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Front.7b2d10b45a66c6d9f1e7b53873456c89.svg";